import PropTypes from 'prop-types';
// material
import { Box, Typography, Divider } from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// components
import PaymentMessage from '../../Message';
import { numberFormat, getTimeZoneDate, getTimeZoneGTM } from '../../../../helpers/Util';

const RootStyle = styled('div')(({ theme }) => ({
  marginBottom: '16px',
  borderRadius: '16px',
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(3),
  border: `1px dashed ${grey[300]}`
}));

PaymentMethodSibsReference.propTypes = {
  transaction: PropTypes.object,
  payment: PropTypes.object
};

export default function PaymentMethodSibsReference({ transaction, payment }) {
  return (
    <RootStyle>
      <Box sx={{ textAlign: 'center' }}>
        <PaymentMessage payment={payment} />
        <Box mb={3}>
          <Box
            sx={{ display: 'inline-block' }}
            src="/static/payment/logo-multibanco.svg"
            component="img"
            height={40}
          />
        </Box>
      </Box>

      <Box margin="auto" maxWidth="400px">
        <Box display="flex" alignItems="center" p={1} maxWidth="420px">
          <Box>
            <Typography gutterBottom variant="body1">
              Entity:
            </Typography>
            <Typography gutterBottom variant="body1">
              Reference:
            </Typography>
            <Typography gutterBottom variant="body1">
              Amount:
            </Typography>
          </Box>
          <Box ml="auto">
            <Typography gutterBottom variant="body1" color="textSecondary" align="right">
              {payment.reference.entity}
            </Typography>
            <Typography gutterBottom variant="body1" color="textSecondary" align="right">
              {payment.reference.reference}
            </Typography>
            <Typography gutterBottom variant="body1" color="textSecondary" align="right">
              {numberFormat(transaction.amount.total)}
            </Typography>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ textAlign: 'center', my: 2 }}>
          <Typography gutterBottom variant="body1">
            Payment Deadline:
          </Typography>
          <Typography gutterBottom variant="body1" color="textSecondary">
            {`${getTimeZoneDate({ date: payment.reference.expiresIn })
              .tz('Europe/Lisbon')
              .format('ddd, DD MMM, HH:mm')}
              (GTM${getTimeZoneGTM({ date: payment.reference.expiresIn })})`}
          </Typography>
        </Box>
      </Box>
    </RootStyle>
  );
}
